import { isSupportedOvertimeTimesheetDuration } from '@sit/core';
import { useGetTimesheet } from '@sit/openapi';
import { useEnabledTimesheetDimensions } from '@web/hooks/useTimesheetDimensions';

export function useShowOvertime({ timesheetId }: { timesheetId: string | undefined }): boolean {
  const { data: timesheet } = useGetTimesheet(timesheetId);
  const showTimeType = useEnabledTimesheetDimensions(timesheetId, ([_, { showTimeType }]) => showTimeType);
  return !!timesheet && showTimeType && isSupportedOvertimeTimesheetDuration(timesheet.timesheetDuration);
}
